var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContracts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_2196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.56055 5.47266V6V6.52734H10.8106V5.47266H2.56055Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81055 2.84766V3.375V3.90234H8.56056V2.84766H4.81055Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3508 1.36297L13.3653 4.00925V0H0.00585938V18H13.3653V9.5156L17.9942 3.34631L15.3508 1.36297ZM12.3106 16.9453H1.06055V1.05469H12.3106V5.41491L10.579 7.72267H2.56056V8.25001V8.77736H9.78766L8.89079 9.97267H2.56056V10.5V11.0274H8.42912L8.70647 12.9715L11.0198 12.6416L12.3106 10.9213V16.9453ZM11.1161 10.7558L10.4384 11.6591L9.60165 11.7784L9.48226 10.9417L10.16 10.0385L11.1161 10.7558ZM11.7491 9.91223L10.793 9.19487L13.0858 6.13909L14.0419 6.85645L11.7491 9.91223ZM13.7188 5.29545L15.5614 2.83957L16.5176 3.55697L14.6749 6.01284L13.7188 5.29545Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99076 13.7222L7.22994 14.2294L6.40233 12.5742L5.36195 13.7222H4.40039V14.7769H5.82949L6.1485 14.4249L6.8209 15.7697L8.31008 14.7769H8.97074V13.7222H7.99076Z",
    fill: "#3F3F46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_2196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContracts);
export default __webpack_public_path__ + "static/media/contracts.fbd582a71e83e654885d446f2d77860c.svg";
export { ForwardRef as ReactComponent };